import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Icon from '../common/atom/Icon';
import { Button } from '../common/atom/Button';
import { ReviewInfo } from './ReviewPossibleListItem';

import * as PATH from '../../lib/routes/path';
import { SocialShareIconButton } from '../common/organism/SocialShare';
import ReviewItemView from '../../domain/Review/Item/ReviewItemView';
import { isReviewContestOn } from '../../lib/image/event/EventReviewContestIcon';

const Box = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 126px;
  box-shadow: 0 2px 15px 0 rgba(88, 82, 105, 0.28);
  background-color: #ffffff;
  padding: 10px;
  & + & {
    margin-top: 20px;
  }
`;

const FirstBox = styled.div`
  display: flex;
  padding-bottom: 10px;
  border-bottom: solid 1px #d8d8d8;
`;

const FirstBoxButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: auto;
  cursor: pointer;
`;

const ModifyButton = styled(Button)`
  position: absolute;
  right: 1.5rem;
  width: 5rem;
`;
const ReviewListItem = ({
  purchasedDate,
  createDateTime,
  text,
  facetImage,
  star,
  likesCount,
  id,
  itemName,
  thumbnail,
  reviewType,
}) => {
  const [checked, setChecked] = useState(false);
  const shareTitle =
    reviewType === 'BABYFACE_AFTER_BIRTH' && isReviewContestOn()
      ? '베이비페이스 생후비교 콘테스트 참여'
      : '베이비페이스 리뷰';

  return (
    <Box>
      <FirstBox>
        <ReviewInfo
          storageUri={thumbnail}
          itemName={itemName}
          createDateTime={purchasedDate}
        />
        <FirstBoxButton>
          <SocialShareIconButton
            params={{
              url: `https://www.babyface.io${PATH.REVIEW_DETAIL}/${id}`,
              title: shareTitle,
              text,
              imageUrl: facetImage.image.storageUri,
            }}
          />
          <Link to={`${PATH.REVIEW_REWRITE}/${id}`}>
            {checked && (
              <ModifyButton size={12} weight="medium">
                수정하기
              </ModifyButton>
            )}
          </Link>
          <Icon
            iconName="more_vert"
            onClick={() => setChecked((prevState) => !prevState)}
          />
        </FirstBoxButton>
      </FirstBox>
      <ReviewItemView
        data={{
          id,
          userName: '작성일: ',
          likesCount,
          star,
          createDateTime,
          reviewImages: [{ image: facetImage.image, id: facetImage.image.id }],
          text,
        }}
      />
    </Box>
  );
};

export default ReviewListItem;
